/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tampilan_S3Inputs */

const en_tut_tampilan_s3 = /** @type {(inputs: Tut_Tampilan_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a **Tema workspace** from five palettes: Bystep, Graphite, Slate, Sand, or Sage. The preview is live.`)
};

const id_tut_tampilan_s3 = /** @type {(inputs: Tut_Tampilan_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih **Tema workspace** dari lima palet: Bystep, Graphite, Slate, Sand, atau Sage. Pratinjaunya langsung terlihat.`)
};

/**
* | output |
* | --- |
* | "Pick a **Tema workspace** from five palettes: Bystep, Graphite, Slate, Sand, or Sage. The preview is live." |
*
* @param {Tut_Tampilan_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tampilan_s3 = /** @type {((inputs?: Tut_Tampilan_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tampilan_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tampilan_s3(inputs)
	return en_tut_tampilan_s3(inputs)
});